let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ivP0X")).then(() => parcelRequire('kJL32'));